
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RateMasterGrid extends Serenity.EntityGrid<RateMasterRow, any> {
        protected getColumnsKey() { return 'OMS.RateMaster'; }
        protected getDialogType() { return RateMasterDialog; }
        protected getIdProperty() { return RateMasterRow.idProperty; }
        protected getInsertPermission() { return RateMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return RateMasterRow.localTextPrefix; }
        protected getService() { return RateMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.push({
                title: 'Import',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new Common.RateImportExcelDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}